export const SN_HISTORY = 'orders'
export const HISTORY_SET_ROUTES = SN_HISTORY + '/SET_ROUTES'
